
import React from 'react';
import { Menu, MenuItem } from '@/types/menu';
import { useMenuItems } from '@/hooks/useMenuItems';
import VirtualMenuSection from '../items/VirtualMenuSection';
import { LanguageCode } from '@/constants/menuUITranslations';

interface SimpleMenuCategoriesProps {
  menuItems: MenuItem[];
  categories: string[];
  activeCategory: string | null;
  menu: Menu;
  isHappyHour: boolean;
  currentLanguage?: LanguageCode;
}

const SimpleMenuCategories: React.FC<SimpleMenuCategoriesProps> = ({ 
  menuItems, 
  categories,
  activeCategory,
  menu,
  isHappyHour,
  currentLanguage = 'fr'
}) => {
  const { categorizedItems } = useMenuItems(menuItems, categories);

  // Only show the active category or first category if none selected
  const categoryToShow = activeCategory || categories[0];
  
  if (!categoryToShow) {
    return null;
  }

  return (
    <div className="flex-1 px-4 pb-6">
      <VirtualMenuSection
        key={categoryToShow}
        category={categoryToShow}
        items={categorizedItems.get(categoryToShow) || []}
        primaryColor={menu.primary_color}
        isHappyHour={isHappyHour}
        currentLanguage={currentLanguage}
      />
    </div>
  );
};

export default SimpleMenuCategories;
